<template>
  <div class="type-dropdown">
    <PillDropdown
      :name="$t('search.typeDropdownName')"
      :allow-multi-select="true"
      :options="typesState"
      @clear-filters="clearFilters"
      @apply-filters="applyFilters"
      @filter-applied="$emit('filterApplied', $event)"
    >
    </PillDropdown>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useSearchFilters } from '@/composables/useSearchFilters';
import PillDropdown from './PillDropdown.vue';
import { trackTypeFilterApplied } from '@/helpers/searchAnalytics';

defineEmits(['filterApplied']);

const { $t } = useNuxtApp();
const route = useRoute();
const { typesState, initializeTypes, selectedTypes } = useSearchFilters();

// Initialize types when component mounts
onMounted(() => {
  const allTypes = [
    { name: $t('search.events.tagName'), type: 'events', idx: 0, checked: false, filterValue: 'events' },
    { name: $t('search.documents.tagName'), type: 'assets', idx: 1, checked: false, filterValue: 'documents' },
    { name: $t('search.athletics.tagName'), type: 'athletics', idx: 2, checked: false, filterValue: 'athletics' },
    { name: $t('search.staff.tagName'), type: 'staff', idx: 3, checked: false, filterValue: 'staff' },
    { name: $t('search.forms.tagName'), type: 'forms', idx: 4, checked: false, filterValue: 'forms' },
    { name: $t('search.liveFeed.tagName'), type: 'live_feeds', idx: 5, checked: false, filterValue: 'live_feed' },
    { name: $t('search.articles.tagName'), type: 'news', idx: 6, checked: false, filterValue: 'news' },
    { name: $t('search.links.tagName'), type: 'links', idx: 7, checked: false, filterValue: 'links' },
    { name: $t('search.pages.tagName'), type: 'pages', idx: 8, checked: false, filterValue: 'pages' },
  ];
  initializeTypes(allTypes);
});

function clearFilters() {
  const newQuery = { ...route.query };
  delete newQuery.query_indices;
  navigateTo({ query: newQuery }, { replace: true });
}

function applyFilters() {
  const selectedTypeOptions = typesState.value.filter((type) => type.checked);
  const filterValues = selectedTypeOptions.map((type) => type.filterValue || type.type);
  if (filterValues.length > 0) {
    trackTypeFilterApplied(filterValues);
  }

  const newQuery = { ...route.query, query_indices: selectedTypes.value };
  navigateTo({ query: newQuery }, { replace: true });
}
</script>
